import * as React from 'react';

import { Button, Grid, TextField } from '@emburse/ui-core';

import { injectCastleRequestToken } from '@ReactComponents/../utils/castle';

export const RedesignedResetPasswordForm: React.FC<{
  csrf: string;
  initialEmail?: string;
}> = ({ csrf, initialEmail }) => {
  const [email, setEmail] = React.useState(initialEmail || '');

  return (
    <form method="POST" action="/reset_password" id="reset_password" autoComplete="off" onSubmit={injectCastleRequestToken}>
      <Grid container direction="column" spacing={2} justifyContent="center" style={{ width: '400px' }}>
        <input type="hidden" name="_csrf" value={csrf} />
        <Grid item>
          <TextField
            required
            type="email"
            name="email"
            label="Enter email"
            fullWidth
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
          />
        </Grid>
        <Grid item>
          <Button type="submit" size="medium" fullWidth>
            Send Recovery Link
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
